import React from 'react'
import styled from 'styled-components'

interface INFTPRiceSymbol {
  symbol: string
  image: string
}

const NFTPriceSymbolWrapper = styled.span`
  width: 100%;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;

  img {
    margin-left: 0.5rem;
    border-radius: 100%;
    width: 20px;
    height: 20px;
  }
`
export default function NFTPriceSymbol({ symbol, image }: INFTPRiceSymbol) {
  return (
    <NFTPriceSymbolWrapper>
      {symbol}
      <img src={image} alt={symbol} />
    </NFTPriceSymbolWrapper>
  )
}
